import React, { useState } from 'react';
import PropTypes from 'prop-types';

import plusIcon from 'assets/plus.svg';
import minusIcon from 'assets/minus.svg';

import { sumAndSubstract } from 'utils/numbers';

import styles from './quantityModifier.module.scss';
import { Box } from '@mui/material';

const QuantityModifierOrd = ({
  product,
  state,
  setState,
  quantityKey,
  newOrder,
  shouldRemoveEmpty = true,
}) => {

  const [displayValues, setDisplayValues] = useState({});

  const modifyProducts = (id, quantity, product) => {
    id = Number(id);
    
    if (quantity === '' || quantity === '.') {
      const copyArray = [...state.products];
      const existingProduct = copyArray.find((product) => product.productId === id);

      if (existingProduct) {
        existingProduct[quantityKey] = 0;
      } else {
        copyArray.push({ ...product, [quantityKey]: 0 });
      }
      
      setState({ ...state, products: copyArray });
      return;
    }
    
    const numericQuantity = parseFloat(quantity);
    
    if (isNaN(numericQuantity)) return;

    const copyArray = [...state.products];
    const existingProduct = copyArray.find((product) => product.productId === id);

    if (existingProduct) {
      existingProduct[quantityKey] = numericQuantity;
    } else {
      copyArray.push({ ...product, [quantityKey]: numericQuantity });
    }
    
    setState({ ...state, products: copyArray });
  };

  const handleInputChange = (id, rawValue, product) => {
    const sanitized = rawValue.replace(/[^0-9.]/g, '');
    if ((sanitized.match(/\./g) || []).length > 1) return;

    setDisplayValues(prev => ({ ...prev, [id]: sanitized }));

    if (sanitized === '' || sanitized === '.') {
      modifyProducts(id, '', product);
    } else {
      modifyProducts(id, sanitized, product);
    }
  };

  const handleBlur = (id, quantity) => {
    id = Number(id);
    
    let cleanValue = typeof quantity === 'string' ? quantity.trim() : String(quantity);
    cleanValue = cleanValue.replace(/[^0-9.]/g, '');
    
    const parts = cleanValue.split('.');
    if (parts.length > 2) {
      cleanValue = parts[0] + '.' + parts.slice(1).join('');
    }
    
    const numericValue = parseFloat(cleanValue);
    const copyArray = [...state.products];
    const productIndex = copyArray.findIndex((product) => product.productId === id);

    if (productIndex !== -1) {
      if (cleanValue === '' || isNaN(numericValue)) {
        copyArray[productIndex][quantityKey] = 0;
        setDisplayValues(prev => ({ ...prev, [id]: '0' }));
      } else {
        copyArray[productIndex][quantityKey] = numericValue;
        setDisplayValues(prev => ({ ...prev, [id]: String(numericValue) }));
      }
      setState({ ...state, products: copyArray });
    }
  };

  const modifyAmount = (operation, id, product) => {
    const currentDisplay = displayValues[id] !== undefined ? displayValues[id] : getInitialInputValue(id);
    const cleanValue = currentDisplay.replace(/,/g, '.');
    let parsedValue = Number(cleanValue);

    if (operation === 'plus') {
      const newValue = sumAndSubstract(parsedValue + 1);
      setDisplayValues(prev => ({ ...prev, [id]: String(newValue) }));
      modifyProducts(id, newValue, product);
    }

    if (operation === 'minus') {
      if (parsedValue > 1) {
        const newValue = sumAndSubstract(parsedValue - 1);
        setDisplayValues(prev => ({ ...prev, [id]: String(newValue) }));
        modifyProducts(id, newValue, product);
      } else {
        setDisplayValues(prev => ({ ...prev, [id]: '0' }));
        handleBlur(id, 0);
      }
    }
  };

  const getInitialInputValue = (id) => {
    for (let i = 0; i < state.products.length; i++) {
      if (state.products[i].productId === id) {
        const value = state.products[i][quantityKey];
        return String(value);
      }
    }
    return '0';
  };

  const isProductInCart = (id) => {
    for (let i = 0; i < state.products.length; i++) {
      if (state.products[i].productId === id) {
        return true;
      }
    }
    return false;
  };

  return (

    
    <Box display={'flex'} flexDirection={'row'} justifyContent={'end'} alignItems={'center'} sx={{ width:{xl:150, lg:180, md:110, sm:110, xs:150} }}>
      <div className={styles.inputContainer}>
        {isProductInCart(product.productId) && (
          <img
            src={minusIcon}
            alt="minusLogo"
            className={`${styles.icon} ${styles.minus}`}
            onClick={() => {
              modifyAmount('minus', product.productId, product);
            }}
          />
        )}

        <input
          className={styles.input}
          name={product.productId}
          type="text"
          inputMode="decimal"
          value={displayValues[product.productId] !== undefined ? displayValues[product.productId] : getInitialInputValue(product.productId)}
          onChange={(e) => handleInputChange(e.target.name, e.target.value, product)}
          onBlur={(e) =>
            setTimeout(() => {
              handleBlur(e.target.name, e.target.value, product);
            }, 250)
          }
          disabled={!isProductInCart(product.productId)}
        />
        {isProductInCart(product.productId) && <span>{product.measurementUnit}</span>}
      </div>
      <img
        src={plusIcon}
        alt="plusLogo"
        className={styles.icon}
        onClick={() => {
          modifyAmount('plus', product.productId, product);
        }}
      />
    </Box>
  );
};

QuantityModifierOrd.propTypes = {
  product: PropTypes.object.isRequired,
  state: PropTypes.object.isRequired,
  setState: PropTypes.func.isRequired,
  quantityKey: PropTypes.string.isRequired,
  shouldRemoveEmpty: PropTypes.bool,
};

export default QuantityModifierOrd;